import React from 'react';

import { Card, Separator } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { EndorsementCardBodyContent } from './components/EndorsementCardBodyContent';
import { EndorsementCardHeader } from './components/EndorsementCardHeader';
import type { EndorsementCardEditProps, FocusedField } from './types';

type DescriptionSectionProps = {
	description: string;
	displaySeparator: boolean;
	isDescriptionPlaceholder: boolean;
	focusedField: FocusedField;
	onReadMore?: () => void;
	readMoreLabel?: string;
};

const DescriptionSection: React.FC<DescriptionSectionProps> = ({
	description,
	displaySeparator,
	isDescriptionPlaceholder,
	focusedField,
	onReadMore,
	readMoreLabel,
}) => {
	if (!description) return null;

	return (
		<>
			{displaySeparator && <Separator orientation="horizontal" className="border-stroke-info-weak my-5 opacity-34" />}
			<EndorsementCardBodyContent
				displayDescription={description}
				isDescriptionPlaceholder={isDescriptionPlaceholder}
				focusedField={focusedField}
				onReadMore={onReadMore}
				readMoreLabel={readMoreLabel}
			/>
		</>
	);
};

export const EndorsementCardEdit: React.FC<EndorsementCardEditProps> = ({
	name = '',
	title = '',
	description = '',
	photoUrl,
	link,
	onEdit,
	onRemove,
	onReadMore,
	readMoreLabel,
	className,
	focusedField = null,
	displaySeparator = false,
	isNamePlaceholder = false,
	isTitlePlaceholder = false,
	isDescriptionPlaceholder = false,
}) => {
	return (
		<Card className={cn('min-w-0 gap-0! overflow-hidden p-6!', className || 'bg-fill-information-weaker border-none')}>
			<EndorsementCardHeader
				displayName={name}
				displayTitle={title}
				photoUrl={photoUrl}
				link={link}
				isNamePlaceholder={isNamePlaceholder}
				isTitlePlaceholder={isTitlePlaceholder}
				focusedField={focusedField}
				onEdit={onEdit}
				onRemove={onRemove}
			/>
			<DescriptionSection
				description={description}
				displaySeparator={displaySeparator}
				isDescriptionPlaceholder={isDescriptionPlaceholder}
				focusedField={focusedField}
				onReadMore={onReadMore}
				readMoreLabel={readMoreLabel}
			/>
		</Card>
	);
};
